
<template>
    <div>
        <div class="row align-items-center">

            <div class="col-lg-6">
                <base-input
                    label="Letter Type"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="record.type"
                    >
                        <option  value="null" disabled>---Select One---</option>
                        <option value="school">School</option>
                        <option value="hospital">Hospital</option>
                        <option value="cpd">CPD Provider</option>
                    </select>
                </base-input>
            </div>

            <div class="col-lg-6">
                <base-input
                    label="Request Type"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="record.request_type"
                    >
                        <option  value="null" disabled>---Select One---</option>
                        <option 
                            value="accreditation"
                            v-if="(record.type == 'hospital')"
                        >
                            Accreditation
                        </option>
                        <option 
                            value="pre-clinical-accreditation"
                            v-if="(record.type == 'school')"
                        >Pre Clinical Accreditation</option>
                        <option 
                            value="first-clinical-accreditation"
                            v-if="(record.type == 'school')"
                        >First Clinical Accreditation</option>
                        <option 
                            value="final-clinical-accreditation"
                            v-if="(record.type == 'school')"
                        >Final Clinical Accreditation</option>
                        <option 
                            value="advisory-visit"
                            v-if="(record.type == 'school')"
                        >Advisory Visit</option>
                        <option value="re-accreditation">Re-accreditation</option>
                    </select>
                </base-input>
            </div>

            <div class="col-lg-12">
                <base-input alternative=""
                    label="Letter Parameters"
                    input-classes="form-control-alternative"
                    v-model="letter.params"
                    readonly
                />
            </div>

            <div class="col-lg-12">
                <h3 class="text-danger">
                    Note that the parameters above are not to be removed/modified from the email content section,
                    other characters can be modified
                </h3>
                <br>
            </div>

            <div class="col-lg-12">
                <base-input alternative=""
                    label="Letter Message Content">
                    <ckeditor
                        :editor="editor"
                        v-model="record.content"
                        :config="editorConfig"
                    ></ckeditor>
                </base-input>   
            </div>

            <div
                class="col-sm-12 text-center"
                v-if='showErrorStatus'
            >
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>

            <hr class="my-4" />

            <div class="col-lg-12">
                <base-button
                    type="success" size="lg"
                    @click="updateLetterRecord()"
                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                >
                    <i class="fa fa-save"></i>
                    {{isloading ? 'Please Wait...' : 'Update Email'}}
                </base-button>

                <base-button
                    type="danger" size="lg"
                    class="right"
                    @click="$emit('showEditPage', false)"
                >
                    <i class="fa fa-times"></i>
                    Cancel
                </base-button>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        name: 'EditLetter',
        props: ['privileges', 'letter', 'loadLetterItems', 'showEditPage'],
        components: {
            ckeditor: CKEditor.component
        },
        data() {
            return {
                record: {
                    type: null,
                    request_type: null,
                    content: null,
                    params: null,
                    id: null,
                    admin_id: null
                },
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [ 'heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList' ],
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false
            }
        },
        methods: {
            ...mapActions(['updateLetter']),
            setData() {// set data for editing
                this.emptyEduRecords();
                let letter = this.letter;
                if(letter) {
                    this.record.type = letter.type;
                    this.record.request_type = letter.request_type;
                    this.record.content = letter.content;
                    this.record.params = letter.params;
                    this.record.id = letter.id;
                }
            },
            emptyEduRecords() {
                this.record = {
                    type: null,
                    request_type: null,
                    content: null,
                    params: null,
                    id: null,
                    admin_id: null
                };
            },
            updateLetterRecord() {
                let status = this.validatedInputs();// validate inputs
                if(status) {// save department
                    let data = this.record;
                    data.admin_id = this.$store.state.user.userId;// add admin user id
                    this.preloader(); // show loading
                    this.updateLetter(data).then((res) => {// update email
                        if(res.status) {
                            this.showEditPage(false);// hide edit page
                            this.loadLetterItems();// refresh page
                            swal.fire("Letter Updated", res.msg, "success");
                        } else {
                            this.loadLetterItems();// refresh page
                            swal.fire("Error Occurred!", res.msg, "warning");
                        }
                    }).
                    catch(err => {
                        this.loadLetterItems();// refresh page
                        swal.fire(err.message+"!", "An error occurred while saving, try again", "warning");
                    });
                }
            },
            validatedInputs() {
                let data = this.record;
                let letter = { type: null, request_type: null, content: null };
                letter.type = data.type == null || data.type == '' ?
                                    this.showInuptError('Select Letter Type') : data.type;
                letter.request_type = data.request_type == null || data.request_type == '' ?
                                    this.showInuptError('Select Request Type') : data.request_type;
                letter.content = data.content == null || data.content == '' ?
                                    this.showInuptError('Enter Letter Content') : data.content;
                return this.isEmpty(letter) ? true : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {// set records
            this.setData();
        }
    };
</script>
<style scoped>
    .right {
        float: right;
    }
    .marginTop40 {
        margin-top: 40px;
    }
</style>